import React from 'react';
import './styles.css';
import GanttHierarki from './components/GanttHierarki';
import Header from './components/Header';
import StructureCard from './components/StructureCard';
import { useProject } from './hooks/useProject';
import { Box, CircularProgress, Alert } from '@mui/material';

export default function GanttNewPage() {
  const { project, loading, error } = useProject();

  return (
    <div className="gantt-new-page">
      <Header projectName={project?.name} loading={loading} />

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error" sx={{ mb: 3 }}>
          Gagal memuat data proyek. Silakan coba lagi.
        </Alert>
      ) : (
        <>
          <StructureCard />
          <section className="gantt-new-content">
            <GanttHierarki />
          </section>
        </>
      )}
    </div>
  );
}
